export const USER_LEVEL = {
  employee: ['prospective_employee'],
  owner: ['contact_person', 'owner', 'agent', 'admin'],
};
